import ErrorNotification from 'src/view/components/notification/error-notification';

export { ErrorNotification };
